import { useState } from 'react';
import { Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
import LoginModal from './LoginModal';
import RegisterModal from './RegisterModal';

export default function Nav() {
  const [loginOpen, setLoginOpen]       = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);

  return (
    <>
      <nav className="nav">
        <div className="nav-in">
          <Link to="/" className="nav-brand">
            <div className="nav-brand-dot" />
            MIG
          </Link>
          <ul className="nav-links">
            <li><a href="/#research">Research</a></li>
            <li><a href="/#projections">Projections</a></li>
            <li><a href="/#track">Track record</a></li>
            <li><a href="/#plans">Plans</a></li>
          </ul>
          <div className="nav-actions">
            <button className="nav-login" onClick={() => setLoginOpen(true)}>
              Log in
            </button>
            <button className="nav-cta" onClick={() => setRegisterOpen(true)}>
              <Zap size={14} /> Start free
            </button>
          </div>
        </div>
      </nav>

      {loginOpen    && <LoginModal    onClose={() => setLoginOpen(false)}
                         onSwitchToRegister={() => { setLoginOpen(false); setRegisterOpen(true); }} />}
      {registerOpen && <RegisterModal onClose={() => setRegisterOpen(false)} initialPlan="free"
                         onSwitchToLogin={() => { setRegisterOpen(false); setLoginOpen(true); }} />}
    </>
  );
}
